.root {
    background: var(--mantine-color-dark-6);
    border: 1px solid var(--mantine-color-dark-4);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;
    height: 100%;
    min-height: 18rem;
}

.title {
    color: var(--mantine-color-white);
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
}

.artWrap {
    align-items: center;
    margin-top: 0.25rem;
}

.valueRow {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 0.25rem;
    color: var(--mantine-color-white);
}

.footer {
    color: var(--mantine-color-dark-1);
    font-size: 0.8125rem;
    text-align: center;
}
